import React, { useEffect, useState } from 'react';
import AuthenticateService from '../auth/AuthenticateService';
import SearchResult from './SearchResult';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faMoon, faSun, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import defaultDp from './../../assets/img/error/default.png';
import { fetchNotifications, markNotificationAsRead } from './services/NotificationService';
import { cartStorage } from './services/cartStorage';
import "./css/style.css";
const Header = (props) => {
  const navigate = useNavigate();
  const { token, logout } = AuthenticateService();
  const [cartCount, setCartCount] = useState(cartStorage.count());

  useEffect(() => {
    const unsubscribe = cartStorage.subscribe(() => setCartCount(cartStorage.count()));
    return unsubscribe;
  }, []);

  const logoutUser = () => {
    if (token != undefined) {
      logout();
    }
  }
  const user = props.user;

  if (user === null) {
    logout();
  }

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0); // Add unread count state

  useEffect(() => {
    const loadNotifications = async () => {
      try {
        setLoading(true);
        const data = await fetchNotifications(token);
        // Update to extract unread count from API response
        setNotifications(data.notifications?.data || []);
        setUnreadCount(data.unread || 0); // Set unread count from API
      } catch (error) {
        console.error("Could not load notifications:", error);
        setNotifications([]);
        setUnreadCount(0); // Reset unread count on error
      } finally {
        setLoading(false);
      }
    };

    loadNotifications();
  }, []); // Empty dependency array means this runs once on mount

  const handleNotificationClick = async (notification) => {
    try {
      // If notification is unread, decrement the unread count
      if (!notification.read_at && unreadCount > 0) {
        setUnreadCount(prevCount => Math.max(0, prevCount - 1));
      }

      // Update local notification state
      setNotifications(prevNotifications =>
        prevNotifications.map(item =>
          item.id === notification.id
            ? { ...item, read_at: new Date().toISOString() }
            : item
        )
      );

      // Navigate to notification details
      navigate('/notifications/details', { state: { notification } });
    } catch (error) {
      console.error("Could not process notification click:", error);
      navigate('/notifications/details', { state: { notification } });
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      // Call mark all as read API
      console.log("mark as read");
      const response = await markNotificationAsRead(token);
      if (response) {
        // Reset unread count to 0
        setUnreadCount(0);

        // Update all notifications to read
        setNotifications(prevNotifications =>
          prevNotifications.map(item => ({
            ...item,
            read_at: item.read_at || new Date().toISOString()
          }))
        );

        console.log('All notifications marked as read');
      }
    } catch (error) {
      console.error("Failed to mark all as read:", error);
    }
  };

  return (
    <>
      <nav className="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
        <div className="collapse navbar-collapse justify-content-between">
          <div className="navbar-logo">
            <button className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#navbarVerticalCollapse" aria-controls="navbarVerticalCollapse" aria-expanded="false" aria-label="Toggle Navigation">
              <span className="navbar-toggle-icon"><span className="toggle-line"></span></span>
            </button>
            <a className="navbar-brand me-1 me-sm-3" href="index.html">
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img src="https://safe.wbalite.com/assets/images/wiredbanking_logo_outline.pn" alt="" width="27" />
                  <p className="logo-text ms-2 d-none d-sm-block">{user?.username}</p>
                </div>
              </div>
            </a>
          </div>

          <span>Welcome, {user?.first_name}</span>

          <ul className="navbar-nav navbar-nav-icons flex-row">
            <li className="nav-item">
              <div className="theme-control-toggle fa-icon-wait px-2">
                <input className="form-check-input ms-0 theme-control-toggle-input" type="checkbox" data-theme-control="phoenixTheme" value="dark" id="themeControlToggle" />
                <label className="mb-0 theme-control-toggle-label theme-control-toggle-light" htmlFor="themeControlToggle" data-bs-toggle="tooltip" data-bs-placement="left" title="Switch theme">
                  <span className="icon">
                    <FontAwesomeIcon icon={faMoon} />
                  </span>
                </label>
                <label className="mb-0 theme-control-toggle-label theme-control-toggle-dark" htmlFor="themeControlToggle" data-bs-toggle="tooltip" data-bs-placement="left" title="Switch theme">
                  <span className="icon">
                    <FontAwesomeIcon icon={faSun} />
                  </span>
                </label>
              </div>
            </li>

            {/* Cart */}
            <li className="nav-item">
              <Link className="nav-link position-relative" to="/cart" title="My Cart">
                <span style={{ height: '20px', width: '20px' }}>
                  <FontAwesomeIcon icon={faShoppingCart} />
                </span>
                {cartCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: '0.65rem', padding: '2px 5px', minWidth: '18px', height: '18px' }}>
                    {cartCount > 99 ? '99+' : cartCount}
                    <span className="visually-hidden">items in cart</span>
                  </span>
                )}
              </Link>
            </li>

            {/* Notification Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link position-relative"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="outside"
                onClick={handleMarkAllAsRead}
              >
                <span style={{ height: '20px', width: '20px' }}>
                  <FontAwesomeIcon icon={faBell} />
                </span>

                {/* Unread Count Badge - Only shows when unreadCount > 0 */}
                {unreadCount > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{
                      fontSize: '0.65rem',
                      padding: '2px 5px',
                      minWidth: '18px',
                      height: '18px'
                    }}>
                    {unreadCount > 99 ? '99+' : unreadCount}
                    <span className="visually-hidden">unread notifications</span>
                  </span>
                )}
              </a>

              <div className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border border-300 navbar-dropdown-caret" id="navbarDropdownNotfication" aria-labelledby="navbarDropdownNotfication">
                <div className="card position-relative border-0">
                  <div className="card-header p-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5 className="text-black mb-0">Notifications</h5>
                      {unreadCount > 0 && (
                        <button
                          className="btn btn-link p-0 fs--1 fw-normal"
                          type="button"
                          onClick={handleMarkAllAsRead}
                          style={{ textDecoration: 'none' }}
                        >
                          Mark all as read
                        </button>
                      )}
                    </div>
                    {unreadCount > 0 && (
                      <div className="mt-1">
                        <small className="text-primary fw-semibold">
                          {unreadCount} unread notification{unreadCount !== 1 ? 's' : ''}
                        </small>
                      </div>
                    )}
                  </div>
                  <div className="card-body p-0">
                    <div className="scrollbar-overlay" style={{ height: '27rem' }}>
                      {loading ? (
                        <div className="text-center p-3">Loading notifications...</div>
                      ) : notifications.length === 0 ? (
                        <div className="text-center p-3">No new notifications</div>
                      ) : (
                        <div className="border-300">
                          {notifications.map((notification) => (
                            <div
                              key={notification.id}
                              className={`px-2 px-sm-3 py-3 border-300 notification-card position-relative ${notification.read_at ? 'read' : 'unread'} border-bottom`}
                              onClick={() => handleNotificationClick(notification)}
                              style={{ cursor: 'pointer' }}
                            >
                              <div className="d-flex align-items-center justify-content-between position-relative">
                                <div className="d-flex">
                                  <div className="avatar avatar-m status-online me-3">
                                    <div className="avatar-name rounded-circle">
                                      <span>N</span>
                                    </div>
                                  </div>
                                  <div className="flex-1 me-sm-3">
                                    <div className="d-flex align-items-center">
                                      <h4 className="fs--1 text-black mb-0">{notification.subject}</h4>
                                      {!notification.read_at && (
                                        <span className="ms-2 badge bg-danger rounded-pill" style={{ fontSize: '0.6rem', padding: '1px 4px' }}>
                                          New
                                        </span>
                                      )}
                                    </div>
                                    <p className="fs--1 text-1000 mb-2 mb-sm-3 fw-normal">
                                      {notification.message}
                                      <span className="ms-2 text-400 fw-bold fs--2">
                                        {new Date(notification.created_at).toLocaleDateString()}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="card-footer p-0 border-top border-0">
                    <div className="my-2 text-center fw-bold fs--2 text-600">
                      <Link className="fw-bolder" to="/notifications/history">Notification history</Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="nav-item dropdown">
              <Link to={'/dashboard'} className="nav-link lh-1 pe-0" id="navbarDropdownUser" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                <div className="avatar avatar-l">
                  <img className="rounded-circle" src={user && user.profile_pic > 10 ? user.profile_pic : defaultDp} alt="" />
                </div>
              </Link>

              <div className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border border-300" aria-labelledby="navbarDropdownUser">
                <div className="card position-relative border-0">
                  <div className="card-body p-0">
                    <div className="text-center pt-4 pb-3">
                      <div className="avatar avatar-xl">
                        <img className="rounded-circle" src={user && user.profile_pic > 10 ? user.profile_pic : defaultDp} alt="" />
                      </div>
                      <h6 className="mt-2 text-black">{user?.first_name} {user?.last_name}</h6>
                    </div>
                  </div>
                  <div className="overflow-auto scrollbar">
                    <ul className="nav d-flex flex-column mb-2 pb-1">
                      <li className="nav-item">
                        <Link to={'/profile'} className="nav-link px-3">
                          <span className="me-2 text-900" data-feather="user"></span>
                          <span>Profile</span>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to={'/dashboard'} className="nav-link px-3">
                          <span className="me-2 text-900" data-feather="pie-chart"></span>
                          Dashboard
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="card-footer p-0 border-top">
                    <hr />
                    <div className="px-3">
                      <a className="btn btn-phoenix-secondary d-flex flex-center w-100" href='#' onClick={logoutUser}>
                        <span className="me-2" data-feather="log-out"></span>
                        Sign out
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <SearchResult />
    </>
  );
}

export default Header;